import React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import classes from './Autotrader_Form.module.css'
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import bitcoin from '../../assets/logo/bitcoin.png'
import premium from '../../assets/logo/premium_user.png'
import basic from '../../assets/logo/basic_user.png'

import ethereum from '../../assets/logo/ethereum.png'
import litecoin from '../../assets/logo/litecoin.png'
import ripple from '../../assets/logo/Ripple.png'
import EOS from '../../assets/logo/eos.png'
import BNB from '../../assets/logo/bnb.png'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Nav from 'react-bootstrap/Nav';
import Order_Table from '../Order_Table/Order_Table'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles';

import Alert from '@mui/material/Alert';


const subscription_link = (props) => {
  var subscription_link

  if (!props.autotrader_info.subscription) {
    subscription_link = <Nav.Item>
      <Nav.Link href="#/profile/subscription">Subscribe to Premium</Nav.Link>
    </Nav.Item>

  }
  else {
    subscription_link = <Nav.Item>
      <Nav.Link href="#/profile/account">Cancel Premium</Nav.Link>
    </Nav.Item>

  }

  return subscription_link;

}



function class_price(value) {
  if ((Number(value)) > 0) {
    if ((Number(value)) > 0.8) {
      return classes.BoldGreen
    }
    return classes.Green
  }
  if ((Number(value)) < 0) {

    if ((Number(value)) < -0.8) {
      return classes.BoldRed
    }
    return classes.Red
  }
}

const subscription_state = (props) => {
  var subscription_status

  if (!props.autotrader_info.subscription) {
    subscription_status = <Col xs={1} md={5}>
      <Image src={basic} roundedCircle />
    </Col>



  }
  else {
    subscription_status =
      <Col xs={1} md={5}>
        <Image src={premium} roundedCircle />
      </Col>





  }

  return subscription_status

}



const useStyles = styled(Paper)(({ theme }) => ({
  height: 90,
  width: 100,
  padding: theme.spacing(2),
}));


export default function Order_history_table(props) {






  return (
    <div>




      {props.userinfo_summary.length !== 0 ?

        <Order_Table data={props.userinfo_summary}></Order_Table>

        : null}



    </div>





  )
};

